import type { QueryClient } from "@tanstack/react-query";
import { collectionKeys } from "@/lib/query-keys";

/**
 * A report holds photos and issues by reference, and its contents carry each
 * one's own fields — a record's cover and photo count, an issue's status,
 * assignee and dates. So a photo or issue changed anywhere (the Photos page, the
 * Issues page, or opened from the report itself) would otherwise sit in the
 * report looking as it did. Only the report on screen refetches; the rest are
 * marked stale.
 *
 * `counts` also refreshes each report's header and the reports list, for a write
 * that moves what they count: a delete (live against removed), or a photo added
 * to or removed from a record (a photos report counts photos, not records).
 * See [[report-detail-page.spec]] § Opening an issue / § Opening a photo.
 */
export function invalidateReportContents(
  queryClient: QueryClient,
  projectId: string,
  { counts = false }: { counts?: boolean } = {},
) {
  void queryClient.invalidateQueries({
    queryKey: collectionKeys.itemsByProject(projectId),
  });
  if (!counts) return;
  void queryClient.invalidateQueries({
    queryKey: collectionKeys.detailsByProject(projectId),
  });
  void queryClient.invalidateQueries({
    queryKey: collectionKeys.list(projectId),
  });
}
